module.exports = __webpack_public_path__ + "assets/images/player4.f0fd5c6df9417104f5bb324bdbff7d83.svg";